import request from '@/utils/request'


// 查询商家进件-拉卡拉列表
export function listExtraApplyLakala(query) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商家进件-拉卡拉分页
export function pageExtraApplyLakala(query) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商家进件-拉卡拉详细
export function getExtraApplyLakala(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/detail',
    method: 'get',
    params: data
  })
}

// 新增商家进件-拉卡拉
export function addExtraApplyLakala(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/add',
    method: 'post',
    data: data
  })
}

// 修改商家进件-拉卡拉
export function updateExtraApplyLakala(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/edit',
    method: 'post',
    data: data
  })
}

// 删除商家进件-拉卡拉
export function delExtraApplyLakala(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/delete',
    method: 'post',
    data: data
  })
}

// 三方进件
export function extraApplyLakalaApply(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/apply',
    method: 'get',
    params: data
  })
}

export function extraApplyLakalaEdit(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/apply/edit',
    method: 'get',
    params: data
  })
}

export function extraApplyLedgerApply(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/ledger/apply',
    method: 'get',
    params: data
  })
}

export function extraApplyLedgerUpdate(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/ledger/update',
    method: 'get',
    params: data
  })
}

export function extraApplyLedgerApplyReceiverNo(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/ledger/apply/receiverNo',
    method: 'get',
    params: data
  })
}

export function ledgerBindList(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/ledger/bind/list',
    method: 'get',
    params: data
  })
}

export function ledgerBind(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/ledger/bind',
    method: 'get',
    params: data
  })
}

export function subInfo(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/sub',
    method: 'get',
    params: data
  })
}

export function balance(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/balance',
    method: 'get',
    params: data
  })
}



export function signExtraApplyEc(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/ec/url',
    method: 'get',
    params: data
  })
}

export function downloadExtraApplyEc(data) {
  return request({
    url: '/biz/admin/merchant/extra/apply/lakala/ec/download',
    method: 'get',
    params: data
  })
}
